import {ReactNode, useState} from "react";
import {Pressable, StyleSheet, ViewStyle} from "react-native";
import {Color} from "@/lib/styles";

type Props = {
    color: string,
    onPress: () => void,
    style?: ViewStyle,
    children?: ReactNode,
}

export default function Editable({children, color, style, onPress}: Props) {
    const [hover, setHover] = useState(false);
    const [focus, setFocus] = useState(false);

    return (
        <Pressable
            focusable={true}
            screenReaderFocusable={true}
            onHoverIn={() => setHover(true)}
            onHoverOut={() => setHover(false)}
            onFocus={()=> setFocus(true)}
            onBlur={()=> setFocus(false)}
            style={[styles.container, {
                borderColor: color,
                outlineColor: focus ? Color.BorderStrong : color,
                outlineWidth: hover || focus ? 1 : 0,
            }, style]}
            onPress={onPress}
        >
            {children}
        </Pressable>
    )
}

export const styles = StyleSheet.create({
    container: {
        borderStyle: "dashed",
        borderRadius: 8,
        borderWidth: 1,
        paddingVertical: 12,
        paddingHorizontal: 12,
        flexWrap: "wrap",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        columnGap: 16,
        rowGap: 4,
        width: "100%",
        outlineStyle: "solid",
    },
})